// Kompass-overlegg: en dedikert kompassrose (SVG) i kartet som roterer med
// kart-bæringen og viser kurs i både grader og NATO-mils (6400). Klikk →
// nullstill nord. Ren DOM/SVG; leser bæring fra MapLibre-kartet.
import { degToMils } from '@skade/contracts';

interface MapLike {
  getBearing(): number;
  resetNorth(): void;
  on(ev: string, fn: () => void): void;
}

export class CompassOverlay {
  readonly el: HTMLElement;
  private roseEl!: HTMLElement;
  private readoutEl!: HTMLElement;

  constructor(private map: MapLike) {
    this.el = this.build();
    this.map.on('rotate', () => this.update());
    this.map.on('load', () => this.update());
    this.update();
  }

  private build(): HTMLElement {
    const wrap = document.createElement('div');
    wrap.className = 'compass-overlay';
    wrap.title = 'Kompass — klikk for å nullstille nord';
    wrap.onclick = () => this.map.resetNorth();
    this.roseEl = document.createElement('div');
    this.roseEl.className = 'compass-rose';
    // Enkel rose: N-pil (rød) + kardinalmerker.
    this.roseEl.innerHTML = `
      <svg viewBox="0 0 100 100" width="100%" height="100%" aria-hidden="true">
        <circle cx="50" cy="50" r="46" class="compass-ring"/>
        <polygon points="50,8 44,50 56,50" class="compass-north"/>
        <polygon points="50,92 44,50 56,50" class="compass-south"/>
        <text x="50" y="20" class="compass-card">N</text>
        <text x="50" y="88" class="compass-card">S</text>
        <text x="86" y="54" class="compass-card">Ø</text>
        <text x="14" y="54" class="compass-card">V</text>
      </svg>`;
    this.readoutEl = document.createElement('div');
    this.readoutEl.className = 'compass-readout';
    wrap.append(this.roseEl, this.readoutEl);
    return wrap;
  }

  update() {
    const bearing = this.map.getBearing(); // grader kartet er rotert
    // Rosen roterer motsatt kartet så N-pila alltid peker geografisk nord.
    this.roseEl.style.transform = `rotate(${-bearing}deg)`;
    const heading = ((bearing % 360) + 360) % 360;
    this.readoutEl.textContent = `${Math.round(heading)}° · ${Math.round(degToMils(heading))} mil`;
  }
}
